<ion-header>
  <ion-toolbar>
    <!-- <ion-buttons slot="start">
      <ion-button color="dark" fill="outline" [strong]="true" (click)="logOut()">Logout</ion-button>
    </ion-buttons> -->
    <ion-title>Are you still there?</ion-title>
    <!-- <ion-buttons slot="end">
      <ion-button (click)="reAuthenticate()" color="dark" fill="outline" [strong]="true">Reauthenticate & Continue</ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<div class="d-message">
  <!-- <h4 class="d-message__header">Are you still there?</h4> -->
    <p class="d-message__message">You have been idle for {{idleTimeInMinutes}} minutes. Do you want to reauthenticate and continue or logout?</p>
      <p class="d-message__message">Time until auto refresh: <span class="remaining-time">{{ timeRemaining$ | async | date:'mm:ss' }}</span>.</p>
    <!-- <p class="d-message__message">Time until auto refresh: <span class="remaining-time">{{ timeRemaining$ | async | date:'mm:ss' }}</span>.</p>  -->
    <!-- <pre>idleTime: {{idleTime}}</pre>
    <pre>logoutTime: {{logoutTime}}</pre> -->
    <!-- <div>
        <ion-button color="dark" fill="outline" [strong]="true" (click)="logOut()">Logout</ion-button>
    </div> -->
    </div>
  <!-- <ion-item>
    <p class="d-message__message">You have been idle for {{idleTimeInMinutes}} minutes. Do you want to reauthenticate and continue or logout?</p>
  </ion-item>
  <ion-item>
    <p class="d-message__message">Time until auto refresh: <span class="remaining-time">{{ timeRemaining$ | async | date:'mm:ss' }}</span>.</p> 
  
  </ion-item> -->
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="dark" fill="outline" [strong]="true" (click)="logOut()">Logout</ion-button>
    </ion-buttons>
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="reAuthenticate()" color="dark" fill="solid" [strong]="true">Continue</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>